import { gql } from '@apollo/client';

export const GET_CART_BY_ID = gql`
  query getCartById($uuid: UUID!) {
    cart(uuid: $uuid) {
      uuid
      userId
      orderOn
      customizeBy
      deliveryDates
      status
      createdAt
      legacyOrderId
      tenantEligibilityConfigLogicalId
      modifiedDuringFunnel
      createdFromPlan {
        id
        logicalId
      }
      createdFromPersonalizedPlan
      subscription {
        uuid
      }
      cartDeliveries {
        id
        createdAt
        updatedAt
        status
        deliveryType
        deliveryDate
        estimatedTransitTime
        estimatedDeliveryDate
        lineItems {
          id
          createdAt
          updatedAt
          variantId
          variant
          price
          quantity
        }
      }
      funnelData
      metroId
      cartLedger {
        subtotal
        discountTotal
        deliveryTotal
        tax
        grandTotal
        creditTotal
        precreditTotal
      }
      discount {
        amount
        code
        type
      }
      cartError {
        validation {
          quantity {
            message
            deliveryId
          }
          status {
            message
          }
          catalog {
            message
          }
          customizeBy {
            message
          }
        }
      }
    }
  }
`;

export const GET_CART_BY_ID_WITH_PREVIEW_FUNNEL_DISCOUNT = gql`
  query getCartByIdWithPreviewFunnelDiscount(
    $uuid: UUID!
    $previewFunnelDiscountCode: Boolean
  ) {
    cart(uuid: $uuid) {
      uuid
      userId
      orderOn
      customizeBy
      deliveryDates
      status
      createdAt
      legacyOrderId
      tenantEligibilityConfigLogicalId
      modifiedDuringFunnel
      createdFromPlan {
        id
        logicalId
      }
      createdFromPersonalizedPlan
      subscription {
        uuid
      }
      cartDeliveries {
        id
        createdAt
        updatedAt
        status
        deliveryType
        deliveryDate
        estimatedTransitTime
        estimatedDeliveryDate
        lineItems {
          id
          createdAt
          updatedAt
          variantId
          variant
          price
          quantity
        }
      }
      funnelData
      metroId
      cartLedger(previewFunnelDiscountCode: $previewFunnelDiscountCode) {
        subtotal
        discountTotal
        deliveryTotal
        tax
        grandTotal
        creditTotal
        precreditTotal
      }
      discount {
        amount
        code
        type
      }
      cartError {
        validation {
          quantity {
            message
            deliveryId
          }
          status {
            message
          }
          catalog {
            message
          }
          customizeBy {
            message
          }
        }
      }
    }
  }
`;

export const GET_CHECKOUT_CART_V2_BY_ID = gql`
  query getCheckoutCartV2ById($uuid: UUID!) {
    cart(uuid: $uuid) {
      uuid
      recipientName
      recipientId
      userId
      orderOn
      customizeBy
      deliveryDates
      status
      createdAt
      legacyOrderId
      tenantEligibilityConfigLogicalId
      modifiedDuringFunnel
      createdFromPlan {
        id
        logicalId
      }
      subscription {
        uuid
      }
      cartDeliveries {
        id
        createdAt
        updatedAt
        status
        deliveryType
        deliveryDate
        estimatedTransitTime
        estimatedDeliveryDate
        lineItems {
          id
          createdAt
          updatedAt
          variantId
          variant
          price
          quantity
        }
      }
      funnelData
      cartLedger {
        subtotal
        discountTotal
        deliveryTotal
        tax
        grandTotal
        creditTotal
        precreditTotal
      }
      discount {
        amount
        code
        type
      }
      cartError {
        validation {
          quantity {
            message
            deliveryId
          }
          status {
            message
          }
          catalog {
            message
          }
          customizeBy {
            message
          }
        }
      }
    }
  }
`;
